import { Alert } from '@prisma/client';
import { createContext, ReactNode, useContext, useState } from 'react';

type DialogType = 'create' | 'edit' | 'delete' | null;

interface AlertsContextType {
  isOpen: DialogType;
  setOpen: (type: DialogType) => void;
  selectedAlert: Alert | null;
  setSelectedAlert: (alert: Alert | null) => void;
}

const AlertsContext = createContext<AlertsContextType | undefined>(undefined);

export function AlertsProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState<DialogType>(null);
  const [selectedAlert, setSelectedAlert] = useState<Alert | null>(null);

  const setOpen = (type: DialogType) => {
    setIsOpen(type);
    if (!type) {
      setSelectedAlert(null);
    }
  };

  return (
    <AlertsContext.Provider
      value={{
        isOpen,
        setOpen,
        selectedAlert,
        setSelectedAlert,
      }}
    >
      {children}
    </AlertsContext.Provider>
  );
}

export function useAlerts() {
  const context = useContext(AlertsContext);
  if (context === undefined) {
    throw new Error('useAlerts must be used within an AlertsProvider');
  }
  return context;
}
